import PredictionConfigProviders from '../../views/Predictions/context/PredictionConfigProviders'

import PredictionsLeaderboard from '../../views/Predictions/Leaderboard'

export default function Leaderboard() {
  return <PredictionsLeaderboard />
}

Leaderboard.Layout = PredictionConfigProviders
